import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtGroup } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    setProjectPermissionsAccountGroupSelected,
} from "client/store"
import {
    UserIcon,
    TableColumn,
    Default,
    DateFormatter,
} from "client/components"

const Columns = () => {
    const selected = useSelector((state: StoreType) => state.projectPermissions.accountGroups.selected)
    const userList = useSelector((state: StoreType) => state.user.userList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectGroup = (group: MtGroup) => {
        let selectedCopy
        if (selected && selected.includes(group.id)) {
            selectedCopy = selected.filter((id) => (id !== group.id))
        } else {
            selectedCopy = selected ? deepCopy(selected) : []
            selectedCopy.push(group.id)
        }
        dispatch(setProjectPermissionsAccountGroupSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectGroup,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            onClick: selectGroup,
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
            onClick: selectGroup,
        },
        {
            field: "creator",
            header: lang.createdBy,
            cellWidth: "200px",
            cellMinWidth: "200px",
            formatter: (group: MtGroup) => {
                if (group.accountId !== userData.accountId && group.accountId === 1) return <Default />

                const user = userList[group.creator]
                return <UserIcon user={user} size="sm" />
            },
            onClick: selectGroup,
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (group: MtGroup) => <DateFormatter date={group.createdAt} />,
            onClick: selectGroup,
        },
    ]

    return columns
}
export default Columns
